module.exports = __webpack_public_path__ + "static/media/batter-icon.a9a0f252.svg";